import React, { Component } from 'react';
import classNames from 'classnames';
import ButtonFace from './buttonFace';
import { playSound } from '../utils/audio';
import { withContext } from '../utils/StateProvider';
import { SPELLS, spellCost, castableOutsideCombat } from '../utils/combat/spells';

// The casting menus, used both in and out of combat:
//   caster -> pick who casts (exploration only)
//   spell  -> pick from the caster's spellbook
//   target -> pick who receives a healing spell
// Number keys pick a character or spell, Esc steps back.
class SpellMenu extends Component {

  componentDidMount() {
    window.addEventListener('keydown', this.handleKeydown);
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.handleKeydown);
  }

  getCaster() {
    const { spellcasting, party } = this.props.context;
    return party.find((c) => c.id === spellcasting.casterId);
  }

  handleKeydown = (e) => {
    const { spellcasting, selectPortrait, chooseSpell, cancelCast } = this.props.context;
    if (e.key === 'Escape') {
      cancelCast();
      return;
    }
    const index = parseInt(e.key, 10) - 1;
    if (isNaN(index) || index < 0) return;
    if (spellcasting.stage === 'spell') {
      const caster = this.getCaster();
      if (index < caster.spells.length) chooseSpell(caster.spells[index]);
    } else {
      selectPortrait(index);
    }
  }

  renderButton(label, onClick, disabled = false, icon) {
    return (
      <div key={label} className={classNames('combat', 'action', { disabled, 'has-icon': icon })} onClick={disabled ? undefined : () => { playSound('click'); onClick(); }}>
        <ButtonFace icon={icon} label={label} />
      </div>
    );
  }

  render() {
    const { spellcasting, combat, chooseSpell, cancelCast } = this.props.context;
    const back = this.renderButton('BACK (ESC)', cancelCast, false, 'back');

    if (spellcasting.stage === 'caster') {
      return (
        <div id="actions" className="combat-menu">
          {back}
          <div className="spell-prompt">Click a portrait or press 1-6</div>
        </div>
      );
    }

    const caster = this.getCaster();

    if (spellcasting.stage === 'target') {
      return (
        <div id="actions" className="combat-menu">
          {back}
          <div className="spell-prompt">Click a portrait or press 1-6</div>
        </div>
      );
    }

    return (
      <div id="actions" className="combat-menu">
        {caster.spells.map((spellId, index) => {
          const spell = SPELLS[spellId];
          const cost = spellCost(spellId, caster);
          // Outside combat only healing can be cast; the rest need a foe
          const unusable = caster.sp < cost || (!combat && !castableOutsideCombat(spell));
          return this.renderButton(`${index + 1}. ${spell.name.toUpperCase()} (${cost} SP)`, () => chooseSpell(spellId), unusable, spell.icon);
        })}
        {back}
      </div>
    );
  }
}

export default withContext(SpellMenu);
